import React, { useEffect, useState } from 'react';

const ANNOUNCEMENTS = [
  {
    emoji: '🎉',
    text: 'First order? Save 10% with code',
    code: 'WELCOME10',
  },
  {
    emoji: '🚚',
    text: 'Free delivery on orders over $50 across the USA',
  },
  {
    emoji: '↩',
    text: '30-day no-questions returns on every order',
  },
];

const STORAGE_KEY = 'jmolux-announcement-dismissed-v1';
const ROTATION_MS = 5000;
const FADE_MS = 300;

const AnnouncementBar = () => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  // Restore dismissed state from localStorage on first mount
  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.localStorage.getItem(STORAGE_KEY) === '1') {
        setDismissed(true);
      }
    } catch (_) {
      /* localStorage might be blocked — fall back to in-memory dismiss only */
    }
  }, []);

  // Rotate messages with a brief fade between them
  useEffect(() => {
    if (dismissed) return undefined;
    const id = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((i) => (i + 1) % ANNOUNCEMENTS.length);
        setVisible(true);
      }, FADE_MS);
    }, ROTATION_MS);
    return () => clearInterval(id);
  }, [dismissed]);

  if (dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    try {
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(STORAGE_KEY, '1');
      }
    } catch (_) {
      /* ignore */
    }
  };

  const current = ANNOUNCEMENTS[index];

  return (
    <div className="relative bg-gradient-to-r from-amber-400 via-yellow-400 to-amber-400 text-black">
      <div className="container mx-auto px-10 sm:px-12 py-2 flex items-center justify-center">
        <p
          className={`text-[11px] sm:text-xs font-medium tracking-wide text-center transition-opacity duration-300 ${
            visible ? 'opacity-100' : 'opacity-0'
          }`}
          aria-live="polite"
        >
          <span className="mr-1.5" aria-hidden="true">
            {current.emoji}
          </span>
          {current.text}
          {current.code && (
            <span className="ml-1.5 inline-block bg-black/10 px-2 py-0.5 rounded font-bold tracking-wider">
              {current.code}
            </span>
          )}
        </p>
      </div>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Dismiss announcement"
        title="Dismiss"
        className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 rounded-full p-1 hover:bg-black/10 active:bg-black/20 transition-colors"
      >
        <svg
          className="w-3.5 h-3.5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          strokeWidth={2.5}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

export default AnnouncementBar;
